import { SidebarMenuCollapsibleItem } from 'app/domains/common-ui';
import { useLinkMatch } from '../useLinkMatch';
export function CollapsibleItemLink(props) {
    const { to, label, matchPath, matchExact = false } = props;
    const active = useLinkMatch({ matchPath, matchExact });
    return <SidebarMenuCollapsibleItem to={to} label={label} active={active}/>;
}
